import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Portal } from 'react-portal';

import './flyout_footer.scss';

const CLASS_NAME = 'brzw-flyout-footer';

const FLYOUT_FOOTER_PORTAL_ID = 'flyout-footer-portal';

class FlyoutFooter extends Component {
  state = {
    flyoutIsOpened: false,
  };

  componentDidMount() {
    this.setState({
      flyoutIsOpened: true,
    });
  }

  render() {
    const { children, classname, v2 } = this.props;
    const { flyoutIsOpened } = this.state;

    if (flyoutIsOpened) {
      return (
        <Portal node={document && document.getElementById(FLYOUT_FOOTER_PORTAL_ID)}>
          <div
            className={classnames(CLASS_NAME, classname, {
              [`${CLASS_NAME}--v2`]: v2,
            })}
          >
            {children}
          </div>
        </Portal>
      );
    }
    return null;
  }
}

FlyoutFooter.propTypes = {
  children: PropTypes.shape({}),
  classname: PropTypes.string,
  v2: PropTypes.bool,
};

FlyoutFooter.defaultProps = {
  classname: '',
};

export default FlyoutFooter;
